import { computed as f, defineComponent as p, ref as b, onMounted as $, nextTick as P } from "vue";
import { DsChip as D, DsContainer as u, DsStatusIcon as k, DsTitle as w, DsIllustration as x, DsPullController as T, DsNavBar as S, DsIslandsContainer as R, DsBackdrop as I, DsCell as G, DsIcon as y, DsAvatarBadge as H, DsDivider as B } from "@ds/vue2";
function o(r, t, e, s, n, i, c, d) {
  var a = typeof r == "function" ? r.options : r;
  t && (a.render = t, a.staticRenderFns = e, a._compiled = !0), s && (a.functional = !0), i && (a._scopeId = "data-v-" + i);
  var _;
  if (c ? (_ = function(l) {
    l = l || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !l && typeof __VUE_SSR_CONTEXT__ < "u" && (l = __VUE_SSR_CONTEXT__), n && n.call(this, l), l && l._registeredComponents && l._registeredComponents.add(c);
  }, a._ssrRegister = _) : n && (_ = d ? function() {
    n.call(
      this,
      (a.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : n), _)
    if (a.functional) {
      a._injectStyles = _;
      var h = a.render;
      a.render = function(C, v) {
        return _.call(v), h(C, v);
      };
    } else {
      var m = a.beforeCreate;
      a.beforeCreate = m ? [].concat(m, _) : [_];
    }
  return {
    exports: r,
    options: a
  };
}
const Y = {
  __name: "DsPaymentPicker",
  props: {
    title: {
      type: String,
      default: ""
    },
    additionalTitle: {
      type: String,
      default: ""
    },
    price: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: 1
    }
  },
  emits: ["input"],
  setup(r, { emit: t }) {
    const e = (n) => {
      t("input", n);
    }, s = f(() => !1);
    return { __sfc: !0, emit: t, clickChipHanlder: e, isSmall: s, DsChip: D, DsContainer: u };
  }
};
var F = function() {
  var t = this, e = t._self._c, s = t._self._setupProxy;
  return e(s.DsContainer, [e("div", { staticClass: "ds-payment-picker" }, [e("div", { staticClass: "ds-payment-picker__container" }, [t.additionalTitle || t.$slots.additionalTitle ? e("div", { staticClass: "ds-payment-picker__addtional-title title-700-heavy", class: { "title-600-heavy": s.isSmall } }, [t._t("addtionalTitle", function() {
    return [t._v(" " + t._s(t.additionalTitle) + " ")];
  })], 2) : t._e(), t.title || t.$slots.title ? e("div", { staticClass: "ds-payment-picker__title title-600-heavy", class: { "title-500-accent": s.isSmall } }, [t._t("title", function() {
    return [t._v(" " + t._s(t.title) + " ")];
  })], 2) : t._e(), t.price || t.$slots.price ? e("div", { staticClass: "ds-payment-picker__price heading-500-accent", class: { "title-700-heavy": s.isSmall } }, [t._t("price", function() {
    return [t._v(" " + t._s(t.price) + " ")];
  })], 2) : t._e()]), t.description || t.$slots.description ? e("div", { staticClass: "ds-payment-picker__description caption-700" }, [t._t("price", function() {
    return [t._v(" " + t._s(t.description) + " ")];
  })], 2) : t._e(), t.$slots.table ? e("div", { staticClass: "ds-payment-picker__table" }, [t._t("table")], 2) : t._e(), t.options.length > 0 || t.$slots.chipGroup ? e("div", { staticClass: "ds-payment-picker__chip-group" }, [t._t("chipGroup", function() {
    return t._l(t.options, function({ label: n, value: i, caption: c }) {
      return e(s.DsChip, { key: i, staticClass: "ds-payment-picker__chip", attrs: { active: t.value === i }, nativeOn: { click: function(d) {
        return s.clickChipHanlder(i);
      } }, scopedSlots: t._u([c ? { key: "caption", fn: function() {
        return [t._v(" " + t._s(c) + " ")];
      }, proxy: !0 } : null, { key: "default", fn: function() {
        return [t._v(" " + t._s(n) + " ")];
      }, proxy: !0 }], null, !0) });
    });
  })], 2) : t._e()])]);
}, O = [], A = /* @__PURE__ */ o(
  Y,
  F,
  O,
  !1,
  null,
  "c135912b",
  null,
  null
);
const St = A.exports, q = /* @__PURE__ */ p({
  __name: "DsPaymentCalendarItem",
  props: {
    title: null,
    overdue: { type: Boolean, default: !1 },
    date: { default: 0 },
    text: { default: "" },
    amount: { default: "" },
    type: { default: "default" },
    status: { default: "default" }
  },
  setup(r) {
    return { __sfc: !0, DsStatusIcon: k };
  }
});
var N = function() {
  var t = this, e = t._self._c, s = t._self._setupProxy;
  return e("div", { staticClass: "ds-payment-calendar-item back-layer1 text-main", class: {
    "ds-payment-calendar-item--overdue": t.overdue,
    "element-fill-dark-disabled": t.status === "disabled",
    "error-back text-inverse-alt": t.status === "blocked"
  } }, [t.overdue ? e("svg", { staticClass: "ds-payment-calendar-item__indicator", attrs: { width: "0.6875rem", height: "0.6875rem", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("path", { attrs: { d: "M9.29289 10.2929L0.707107 1.70711C0.0771421 1.07714 0.523309 0 1.41421 0H10C10.5523 0 11 0.447715 11 1V9.58579C11 10.4767 9.92286 10.9229 9.29289 10.2929Z", fill: "#363636" } })]) : t._e(), e("div", { staticClass: "ds-payment-calendar-item__title label-600 mb-450" }, [t._v(t._s(t.title))]), t.status !== "disabled" ? [e("div", { staticClass: "ds-payment-calendar-item__status mb-450" }, [t.status === "success" ? e("div", { staticClass: "ds-payment-calendar-item__status--success" }, [e(s.DsStatusIcon, { attrs: { type: "success", size: "medium" } })], 1) : e("div", { staticClass: "ds-payment-calendar-item__status--date body-500" }, [e("span", [t._v(" " + t._s(t.date) + " ")])])]), t.amount ? e("div", { staticClass: "ds-payment-calendar-item__amount body-500", class: {
    "pb-450": t.type === "link" || t.type === "description" || t.type === "default"
  } }, [t._v(" " + t._s(t.amount) + " ")]) : t._e()] : t._e(), e("div", { staticClass: "ds-payment-calendar-item__text", class: {
    "caption-600 text-additional": t.type === "caption" || t.status === "disabled",
    "caption-600 text-warning-validation": t.type === "validation",
    "caption-700 text-additional": t.type === "description",
    "label-500 text-action-link": t.type === "link",
    "text-action-link-alt": t.type === "link" && t.status === "blocked"
  } }, [t._v(" " + t._s(t.text) + " ")])], 2);
}, M = [], U = /* @__PURE__ */ o(
  q,
  N,
  M,
  !1,
  null,
  "a8bb095f",
  null,
  null
);
const Rt = U.exports, E = /* @__PURE__ */ p({
  __name: "DsPaymentCalendarGroupTitle",
  setup(r) {
    const t = b(null);
    return $(() => {
      const e = document.querySelector(".ds-payment-calendar__block-title");
      e && P(() => {
        const s = e.getBoundingClientRect().y;
        t.value && (t.value.style.top = `${s}px`);
      });
    }), { __sfc: !0, titleRef: t, DsTitle: w };
  }
});
var L = function() {
  var t = this, e = t._self._c, s = t._self._setupProxy;
  return e("div", { ref: "titleRef", staticClass: "ds-payment-calendar__block-title" }, [e(s.DsTitle, { attrs: { size: "h2" } }, [t._t("default")], 2)], 1);
}, z = [], V = /* @__PURE__ */ o(
  E,
  L,
  z,
  !1,
  null,
  null,
  null,
  null
);
const It = V.exports;
const X = {};
var W = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-payment-calendar" }, [t._t("default")], 2);
}, Z = [], J = /* @__PURE__ */ o(
  X,
  W,
  Z,
  !1,
  null,
  null,
  null,
  null
);
const Gt = J.exports;
const K = {
  components: {
    DsIllustration: x,
    DsPullController: T,
    DsNavBar: S,
    DsContainer: u,
    DsIslandsContainer: R
  },
  props: {
    navbarTitle: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      required: !0
    },
    info: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "text-inverse"
    },
    illustrationName: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      contentPosition: 0,
      scrollProgress: 0,
      prevY: null,
      currY: null,
      scrollTimeout: null,
      isTouching: !1
    };
  },
  mounted() {
    this.init();
  },
  updated() {
    this.init();
  },
  methods: {
    init() {
      this.contentPosition = this.$refs.content.offsetHeight;
    },
    scrollHandler() {
      window.requestAnimationFrame(() => {
        this.scrollProgress = Math.min(
          (this.$refs.scrollContainer.getBoundingClientRect().top + this.contentPosition - this.$refs.card.getBoundingClientRect().top) / this.contentPosition,
          1
        ), this.isTouching || this.makeScroll();
      });
    },
    touchStartHandler() {
      window.clearTimeout(this.scrollTimeout), window.requestAnimationFrame(() => {
        this.isTouching = !0, this.currY = this.$refs.card.getBoundingClientRect().top, this.prevY = null;
      });
    },
    touchMoveHandler() {
      window.requestAnimationFrame(() => {
        const r = this.$refs.card.getBoundingClientRect().top;
        Math.abs(r - this.currY) < 2 || (this.prevY = this.currY, this.currY = r);
      });
    },
    touchEndHandler() {
      window.requestAnimationFrame(() => {
        this.isTouching = !1, this.makeScroll();
      });
    },
    makeScroll() {
      window.clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
        this.scrollProgress >= 1 || this.currY === null || this.prevY === null || (this.currY < this.prevY ? this.scrollToCard() : this.scrollToTop(), this.currY = null, this.prevY = null);
      }, 100);
    },
    scrollToTop() {
      this.$refs.scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToCard() {
      this.$refs.scrollContainer.scrollTo({ top: this.contentPosition, behavior: "smooth" });
    }
  }
};
var Q = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-hero-product", style: { color: `var(--${t.color})` }, on: { touchstart: t.touchStartHandler, touchend: t.touchEndHandler, touchmove: t.touchMoveHandler } }, [e("div", { ref: "navbar", staticClass: "ds-hero-product__navbar", on: { click: t.scrollToTop } }, [e("DsNavBar", { style: { color: `var(--${t.color})` }, attrs: { transparent: "" }, scopedSlots: t._u([{ key: "left", fn: function() {
    return [t._t("navbar-left")];
  }, proxy: !0 }, { key: "right", fn: function() {
    return [t._t("navbar-right")];
  }, proxy: !0 }], null, !0) }, [t.scrollProgress > 0.5 ? e("div", { staticClass: "ds-hero-product__navbar-container", style: { opacity: t.scrollProgress * 2 - 1 } }, [e("div", { staticClass: "ds-hero-product__navbar-title" }, [t._v(t._s(t.title))]), e("div", { staticClass: "ds-hero-product__navbar-subtitle caption-500", domProps: { innerHTML: t._s(t.value) } })]) : e("div", { staticClass: "ds-hero-product__navbar-title", style: { opacity: 1 - t.scrollProgress * 2 } }, [t._v(" " + t._s(t.navbarTitle) + " ")])])], 1), e("div", { staticClass: "ds-hero-product__background-container" }, [e("div", { style: { height: `${t.contentPosition}px` } }), e("div", { staticClass: "ds-hero-product__background", style: { color: `var(--${t.background})` } }), e("div", { staticClass: "ds-hero-product__image", style: {
    opacity: 1 - t.scrollProgress,
    transform: `translateY(-${t.scrollProgress * 5}%)`
  } }, [e("DsIllustration", { attrs: { name: t.illustrationName, type: "wide" } })], 1), e("div", { staticClass: "ds-hero-product__dimmer", style: { transform: `translateY(-${t.contentPosition * t.scrollProgress}px)` } })]), e("div", { ref: "scrollContainer", staticClass: "ds-hero-product__scroll-container", on: { scroll: t.scrollHandler } }, [e("div", { ref: "content", staticClass: "ds-hero-product__content", style: { opacity: 1 - t.scrollProgress } }, [e("DsContainer", { staticClass: "ds-hero-product__text" }, [e("div", { staticClass: "ds-hero-product__heading" }, [e("div", { staticClass: "ds-hero-product__title title-600-heavy" }, [t._v(t._s(t.title))]), t.info ? e("div", { staticClass: "ds-hero-product__info-wrapper body-300" }, [e("span", { staticClass: "ds-hero-product__info" }, [t._v(t._s(t.info))])]) : t._e()]), e("div", { staticClass: "ds-hero-product__value-wrapper" }, [t.$props.description ? e("div", { staticClass: "ds-hero-product__description body-500" }, [t._v(t._s(t.description))]) : t._e(), e("div", { staticClass: "ds-hero-product__value heading-500-accent", domProps: { innerHTML: t._s(t.value) } })])]), t.$slots["status-group"] ? e("div", { staticClass: "ds-hero-product__status-group" }, [t._t("status-group")], 2) : t._e()], 1), e("div", { ref: "card", staticClass: "ds-hero-product__card" }, [e("DsIslandsContainer", [t._t("default")], 2)], 1)]), e("div", { staticClass: "ds-hero-product__loader" })]);
}, j = [], tt = /* @__PURE__ */ o(
  K,
  Q,
  j,
  !1,
  null,
  "18b23381",
  null,
  null
);
const Ht = tt.exports;
const et = {
  name: "DsPartnersGridRow"
};
var st = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-partners-grid__row" }, [t._t("default")], 2);
}, rt = [], nt = /* @__PURE__ */ o(
  et,
  st,
  rt,
  !1,
  null,
  "2505e0a0",
  null,
  null
);
const at = nt.exports, g = ["image", "logo"];
const it = {
  props: {
    type: {
      type: String,
      default: "image",
      validator: (r) => g.includes(r)
    },
    name: String,
    imageUrl: String,
    logoUrl: String,
    url: String,
    textToken: {
      type: String,
      default: "label-500"
    }
  },
  computed: {
    isLogo() {
      return this.type === "logo";
    }
  }
};
var ot = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-grid-item" }, [t.isLogo ? e("div", { staticClass: "ds-grid-item__logo-wrapper" }, [e("img", { staticClass: "ds-grid-item__logo ds-grid-item__logo--medium", attrs: { src: t.logoUrl } })]) : e("div", { staticClass: "ds-grid-item__image-wrapper" }, [e("img", { staticClass: "ds-grid-item__image", attrs: { src: t.imageUrl } }), e("img", { staticClass: "ds-grid-item__logo ds-grid-item__logo--large", attrs: { src: t.logoUrl } })]), t.$slots.link ? e("div", { staticClass: "ds-grid-item__link" }, [t._t("link")], 2) : t._e(), t._t("name", function() {
    return [e("div", { staticClass: "ds-grid-item__label", class: t.textToken }, [t._v(t._s(t.name))])];
  })], 2);
}, lt = [], _t = /* @__PURE__ */ o(
  it,
  ot,
  lt,
  !1,
  null,
  "e3b696bd",
  null,
  null
);
const ct = _t.exports;
const dt = {
  components: { PartnersGridItem: ct, DsPartnersGridRow: at },
  props: {
    type: {
      type: String,
      default: "image",
      validator: (r) => g.includes(r)
    },
    textToken: {
      type: String,
      default: "label-500"
    },
    partners: {
      type: Array
    },
    rows: {
      type: Number,
      default: 1
    },
    rowItems: {
      type: Number,
      default: 4
    }
  },
  emits: ["url"]
};
var ut = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-partners-grid" }, [t._t("default", function() {
    return t._l(t.rows, function(s) {
      return e("DsPartnersGridRow", { key: s }, t._l(t.partners.slice(0 + t.rowItems * (s - 1), t.rowItems * s), function(n) {
        return e("PartnersGridItem", t._b({ key: n.name, attrs: { "text-token": t.textToken, type: t.type }, nativeOn: { click: function(i) {
          return t.$emit("url", { ...n });
        } } }, "PartnersGridItem", n, !1));
      }), 1);
    });
  }, { rows: t.rows })], 2);
}, pt = [], mt = /* @__PURE__ */ o(
  dt,
  ut,
  pt,
  !1,
  null,
  "80f8a064",
  null,
  null
);
const Bt = mt.exports;
const vt = {
  name: "DsDropdownPayment",
  components: {
    DsBackdrop: I,
    DsCell: G,
    DsContainer: u,
    DsIcon: y,
    DsAvatarBadge: H
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    hint: {
      type: String,
      default: ""
    },
    readonly: Boolean,
    custom: Boolean
  },
  emits: ["input", "click"],
  data() {
    return { isOpen: !1 };
  },
  methods: {
    open(r) {
      if (!this.readonly) {
        if (this.custom) {
          this.$emit("click", r);
          return;
        }
        this.isOpen = !0;
      }
    },
    clickValueHandler(r) {
      this.isOpen = !1, this.$emit("input", r);
    }
  }
};
var ft = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-dropdown-payment", class: { "ds-dropdown-payment--readonly": t.readonly } }, [e("button", { staticClass: "ds-dropdown-payment__field", on: { click: function(s) {
    return s.preventDefault(), t.open.apply(null, arguments);
  } } }, [t.value ? [e("span", { staticClass: "ds-dropdown-payment__badge" }, [e("DsAvatarBadge", { attrs: { badge: t.value.badge } })], 1), e("span", { staticClass: "ds-dropdown-payment__left body-500" }, [t._v(t._s(t.value.label))]), e("span", { staticClass: "ds-dropdown-payment__right body-500" }, [t._v(" " + t._s(t.value.value) + " ")])] : [e("span", { staticClass: "ds-dropdown-payment__left ds-dropdown-payment__label caption-700" }, [t._v(t._s(t.label))]), e("span", { staticClass: "ds-dropdown-payment__right" }, [e("DsIcon", { staticClass: "ds-dropdown-payment__icon", attrs: { name: "system/details-ios-500", color: "icon-brand" } })], 1)]], 2), t.hint ? e("div", { staticClass: "ds-dropdown-payment__hint caption-500" }, [t._v(t._s(t.hint))]) : t._e(), t.custom ? t._e() : e("DsBackdrop", { attrs: { title: t.label }, model: { value: t.isOpen, callback: function(s) {
    t.isOpen = s;
  }, expression: "isOpen" } }, t._l(t.options, function(s, n) {
    return e("DsCell", { key: n, staticClass: "ds-dropdown-payment__option", attrs: { tag: "button", multiline: "" }, nativeOn: { click: function(i) {
      return t.clickValueHandler(s);
    } }, scopedSlots: t._u([{ key: "left", fn: function() {
      return [e("DsAvatarBadge", { attrs: { badge: s.badge } })];
    }, proxy: !0 }, { key: "default", fn: function() {
      return [t._v(t._s(s.label))];
    }, proxy: !0 }, { key: "right", fn: function() {
      return [t._v(t._s(s.value))];
    }, proxy: !0 }], null, !0) });
  }), 1)], 1);
}, yt = [], gt = /* @__PURE__ */ o(
  vt,
  ft,
  yt,
  !1,
  null,
  "ef4a2378",
  null,
  null
);
const Yt = gt.exports;
const ht = {
  name: "DsDropdownPaymentGroup",
  components: {
    DsIcon: y
  }
};
var Ct = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-dropdown-payment-container" }, [e("div", { staticClass: "ds-dropdown-payment-container__from" }, [t._t("from")], 2), e("div", { staticClass: "ds-dropdown-payment-container__arrow-wrapper" }, [e("div", { staticClass: "ds-dropdown-payment-container__arrow" }, [e("DsIcon", { attrs: { name: "system/chevron-down-400", color: "icon-light" } })], 1)]), e("div", { staticClass: "ds-dropdown-payment-container__to" }, [t._t("to")], 2)]);
}, bt = [], $t = /* @__PURE__ */ o(
  ht,
  Ct,
  bt,
  !1,
  null,
  "9dd3e883",
  null,
  null
);
const Ft = $t.exports, Pt = /* @__PURE__ */ p({
  __name: "DsCellPaymentProgress",
  props: {
    total: null,
    paid: null,
    payments: null,
    divider: { type: Boolean, default: !1 }
  },
  setup(r) {
    const t = r, e = f(() => t.paid / t.total * 100);
    function s(n, i, c) {
      const d = Math.floor(100 / c.length * 100) / 100, a = d * n;
      return i > a ? 100 : a - d > i ? 0 : (i - d * (n - 1)) * 100 / d;
    }
    return { __sfc: !0, props: t, progress: e, getPeriodProgress: s, DsContainer: u, DsDivider: B };
  }
});
var Dt = function() {
  var t = this, e = t._self._c, s = t._self._setupProxy;
  return e(s.DsContainer, { staticClass: "ds-cell-payment-progress caption-500 pt-450" }, [e("div", { staticClass: "ds-cell-payment-progress__logo pr-500" }, [t._t("logo")], 2), e("div", { staticClass: "ds-cell-payment-progress__content" }, [e("div", { staticClass: "ds-cell-payment-progress__text-wrapper body-500 mb-350" }, [e("div", { staticClass: "ds-cell-payment-progress__text-left" }, [t._t("text-left")], 2), e("div", { staticClass: "ds-cell-payment-progress__text-right" }, [t._t("text-right")], 2)]), e("div", { staticClass: "ds-cell-payment-progress__text-wrapper caption-500 mb-450 text-secondary" }, [e("div", { staticClass: "ds-cell-payment-progress__caption-left" }, [t._t("caption-left")], 2), e("div", { staticClass: "ds-cell-payment-progress__caption-right" }, [t._t("caption-right")], 2)]), e("div", { staticClass: "ds-cell-payment-progress__items mb-450" }, t._l(t.payments, function(n, i) {
    return e("div", { key: `period-${n.date}`, staticClass: "ds-cell-payment-progress__payment" }, [e("div", { staticClass: "ds-cell-payment-progress__indicator_wrapper" }, [e("div", { staticClass: "ds-cell-payment-progress__indicator", style: {
      width: `${s.getPeriodProgress(i + 1, s.progress, t.payments)}%`
    } })]), e("div", { staticClass: "ds-cell-payment-progress__date" }, [t._t(`period-date-${i}`, function() {
      return [t._v(t._s(n.date))];
    })], 2), e("div", { staticClass: "ds-cell-payment-progress__sum" }, [t._t(`period-sum-${i}`, function() {
      return [t._v(t._s(n.sum))];
    })], 2)]);
  }), 0), t.divider ? e(s.DsDivider) : t._e()], 1)]);
}, kt = [], wt = /* @__PURE__ */ o(
  Pt,
  Dt,
  kt,
  !1,
  null,
  null,
  null,
  null
);
const Ot = wt.exports;
export {
  Ot as DsCellPaymentProgress,
  Yt as DsDropdownPayment,
  Ft as DsDropdownPaymentGroup,
  Ht as DsHeroProduct,
  Bt as DsPartnersGrid,
  ct as DsPartnersGridItem,
  at as DsPartnersGridRow,
  Gt as DsPaymentCalendar,
  It as DsPaymentCalendarGroupTitle,
  Rt as DsPaymentCalendarItem,
  St as DsPaymentPicker
};
